import types from "store/types";
import ajax from "utils/ajax";
import { routes } from "config/routes";
import apiActions from "config/apiActions";
import { QUESTION_TYPES } from "src/global";

// initial state, with craft backend or empty
const initData = JSON.parse(JSON.stringify(window.__initialData__));
const state = {
    formOfEnterprises: [],
    typeOfEnterprises: initData.typeOfEnterprises
        ? initData.typeOfEnterprises
        : [],
    isFetch: false,
};

// getters, make function easy to access by vue
//instead
const getters = {
    getFormOfEnterpriseById: (state) => (id) =>
        state.formOfEnterprises.find((q) => q.id === id),
    getFormOfEnterpriseBySlug: (state) => (slug) =>
        state.formOfEnterprises.find((q) => q.slug === slug),
    getFormOfEnterpriseByIdx: (state) => (idx) =>
        state.formOfEnterprises.find((q) => q.idx === parseInt(idx)),
    getTypeOfEnterpriseById: (state) => (id) =>
        state.typeOfEnterprises.find((q) => q.id === id),
};

// actions
const actions = {
    [types.GET_FORM_OF_ENTERPRISES](store) {
        if (store.state.isFetch) {
            return Promise.resolve(store.state.formOfEnterprises);
        }
        return new Promise((resolve, reject) => {
            ajax({
                url: apiActions.formOfEnterprises.getAll,
                method: "get",
            })
                .then((data) => {
                    if (data.success) {
                        let formOfEnterprises = data.formOfEnterprises;

                        // First, link each form to its type
                        formOfEnterprises.forEach((form) => {
                            const type = store.state.typeOfEnterprises.find(
                                (type) =>
                                    parseInt(type.id) === parseInt(form.typeId)
                            );
                            if (type) {
                                form.typeOfEnterprise = type;
                            }
                        });

                        // Then commit the mutation with the linked data
                        store.commit(
                            types.GET_FORM_OF_ENTERPRISES,
                            formOfEnterprises
                        );
                        resolve(formOfEnterprises);
                    } else {
                        reject(data);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

// mutations
const mutations = {
    [types.GET_FORM_OF_ENTERPRISES](state, formOfEnterprises) {
        state.formOfEnterprises = formOfEnterprises;
        state.isFetch = true;

        // Create a deep copy of typeOfEnterprises
        let typeOfEnterprises = JSON.parse(
            JSON.stringify(state.typeOfEnterprises)
        );

        // Initialize empty formOfEnterprises arrays for each type
        typeOfEnterprises.forEach((type) => {
            type.formOfEnterprises = [];
        });

        // Link formOfEnterprises to their types
        formOfEnterprises.forEach((form) => {
            // Find the matching type by id
            const typeForForm = typeOfEnterprises.find(
                (type) => parseInt(type.id) === parseInt(form.typeId)
            );
            if (typeForForm) {
                // Add the form to the type's formOfEnterprises array
                typeForForm.formOfEnterprises.push(form);
            }
        });

        // Update the state with the linked data
        state.typeOfEnterprises = typeOfEnterprises;
    },
};

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations,
};
